import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { reopenAvailability } from '../../redux/availabilitySlice';

const PaymentCanceledPage = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  useEffect(() => {
    const availabilityId = sessionStorage.getItem("pendingAvailabilityId");
    if (availabilityId) {
      dispatch(reopenAvailability(availabilityId));
      sessionStorage.removeItem("pendingAvailabilityId");
      sessionStorage.removeItem("pendingTherapistId");
    }
  }, [dispatch]);

  const handleGoHome = () => {
    navigate('/');
  };

  const handleRetry = () => {
    navigate(-1);
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#E8FFEE]">
      <div className="bg-white rounded-[30px] p-8 max-w-md w-full mx-4 text-center">
        {/* Warning Icon */}
        <div className="w-20 h-20 bg-yellow-100 rounded-full flex items-center justify-center mx-auto mb-6">
          <svg className="w-10 h-10 text-yellow-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-2.5L13.732 4c-.77-.833-1.964-.833-2.732 0L4.082 16.5c-.77.833.192 2.5 1.732 2.5z"></path>
          </svg>
        </div>
        
        <h2 className="font-poppins font-bold text-2xl text-primary mb-4">
          Ödeme İptal Edildi
        </h2>
        
        <p className="font-poppins text-gray-600 mb-6">
          Ödeme işlemi iptal edildi. Herhangi bir ücret tahsil edilmemiştir.
        </p>
        
        <p className="font-poppins text-sm text-gray-500 mb-6">
          İstediğiniz zaman tekrar ödeme yapabilirsiniz.
        </p>

        <div className="flex flex-col gap-3">
          <button
            onClick={handleRetry}
            className="w-full py-3 px-4 rounded-[25px] bg-primary text-white font-poppins font-bold hover:bg-green-700 transition-colors duration-300"
          >
            Tekrar Dene
          </button>
          <button
            onClick={handleGoHome}
            className="w-full py-3 px-4 rounded-[25px] border border-primary text-primary font-poppins font-bold hover:bg-gray-50 transition-colors duration-300"
          >
            Ana Sayfaya Dön
          </button>
        </div>
      </div>
    </div>
  );
};

export default PaymentCanceledPage;
